/**
 * Helper for getting the storage id for objects with overlays.
 * When an object is returned with an overlay, its storage ID
 * in redux will be in the format objectId-overlayHash
 */
export const getObjectWithOverlayStorageId = (objectId?: string, overlayHash?: string) =>
  objectId && overlayHash ? `${objectId}-${overlayHash}` : objectId ?? '';
